export default {
  routeNotFound: 'Zapisany adres URL nie został znaleziony',
};
